import React from 'react';
import { Header } from 'widgets';
import { PageLayout } from 'shared/ui';
import styles from './license-agreement.page.module.scss';

export const LicenseAgreementPage: React.FC = () => {
  return (
    <PageLayout>
      <Header hideSignInButton />
      <div className={styles.page__content}>
        <h1 className={styles.content__title}>
          Лицензионный договор (Оферта для бизнеса)
        </h1>
        <p className={styles.content__date}>
          с поручением на обработку персональных данных (DPA)
        </p>
        <p className={styles.content__date}>Дата публикации: 17 июня 2026 г.</p>
        <p className={styles.content__date}>
          Лицензиар: Самозанятый, ИНН 212710062014
        </p>

        <p>
          Настоящий документ является официальным предложением (офертой)
          Лицензиара заключить Лицензионный договор на указанных ниже условиях.
          Акцепт оферты осуществляется способами, указанными в разделе 3
          настоящего Договора.
        </p>

        <section className={styles.content__section}>
          <h2>Часть 1. Лицензионный договор</h2>

          <h3>1. Термины и определения</h3>
          <p>
            <strong>Лицензиар</strong> — Самозанятый, ИНН 212710062014,
            правообладатель программного обеспечения BookUp.
          </p>
          <p>
            <strong>Лицензиат</strong> — юридическое лицо, индивидуальный
            предприниматель или самозанятый, заключивший Договор.
          </p>
          <p>
            <strong>ПО (Платформа, Сервис, BookUp)</strong> — SaaS-платформа для
            управления записью клиентов.
          </p>
          <p>
            <strong>Тариф</strong> — набор функциональных возможностей ПО и
            условий использования.
          </p>
          <p>
            <strong>Сотрудник</strong> — физическое лицо, добавленное
            Лицензиатом в ПО. Количество Сотрудников определяет стоимость
            Тарифа.
          </p>
          <p>
            <strong>Платёжный период</strong> — период, за который производится
            оплата (1, 3, 6 или 12 месяцев).
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>2. Предмет договора</h3>
          <p>
            2.1. Лицензиар предоставляет право использования ПО функционально
            соответствующего выбранному Тарифу, способом «SaaS» — удалённый
            доступ через сеть Интернет, без получения копии ПО в собственность.
          </p>
          <p>2.2. ПО предоставляется «как есть» (as is).</p>
          <p>
            2.3. Лицензиар вправе изменять функциональность с уведомлением за 14
            дней. Изменения не могут существенно снижать возможности в рамках
            оплаченного Тарифа.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>3. Порядок заключения договора</h3>
          <p>
            3.1. Договор является официальной публичной офертой (ст. 435, 437,
            438 ГК РФ).
          </p>
          <p>
            3.2. Акцептом считается: регистрация учётной записи, начало
            использования ПО, или первый платёж.
          </p>
          <p>
            3.3. Заключая Договор, Лицензиат подтверждает ознакомление с его
            условиями, Политикой обработки персональных данных, и достоверность
            предоставленной информации.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>4. Тарифы и порядок расчётов</h3>

          <h4>4.1. Тарифы</h4>
          <p>
            <strong>Тариф «FREE»</strong> — бесплатный. До 2 сотрудников,
            стоимость 0 рублей.
          </p>
          <p>
            <strong>Тариф «BASE»</strong> — платный. До 15 сотрудников, при
            необходимости использования для большего количества — по отдельному
            соглашению. Стоимость:
          </p>
          <table>
            <thead>
              <tr>
                <th>Количество Сотрудников</th>
                <th>Ставка за Сотрудника в месяц</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2</td>
                <td>270 рублей</td>
              </tr>
              <tr>
                <td>3</td>
                <td>300 рублей</td>
              </tr>
              <tr>
                <td>4</td>
                <td>330 рублей</td>
              </tr>
              <tr>
                <td>5</td>
                <td>360 рублей</td>
              </tr>
              <tr>
                <td>6</td>
                <td>390 рублей</td>
              </tr>
              <tr>
                <td>7</td>
                <td>420 рублей</td>
              </tr>
              <tr>
                <td>8</td>
                <td>450 рублей</td>
              </tr>
              <tr>
                <td>9</td>
                <td>480 рублей</td>
              </tr>
              <tr>
                <td>10</td>
                <td>510 рублей</td>
              </tr>
              <tr>
                <td>11</td>
                <td>540 рублей</td>
              </tr>
              <tr>
                <td>12</td>
                <td>560 рублей</td>
              </tr>
              <tr>
                <td>13</td>
                <td>570 рублей</td>
              </tr>
              <tr>
                <td>14</td>
                <td>580 рублей</td>
              </tr>
              <tr>
                <td>15</td>
                <td>600 рублей</td>
              </tr>
            </tbody>
          </table>
          <p>
            Формула:{' '}
            <strong>
              Количество Сотрудников × Ставка × Количество месяцев
            </strong>
            .
          </p>
          <p>
            При количестве сотрудников более 15 стоимость устанавливается по
            отдельному соглашению.
          </p>
          <p>
            Лицензиар вправе изменять стоимость с уведомлением за 14 дней.
            Изменения не применяются к оплаченным периодам.
          </p>

          <h4>4.2. Скидки</h4>
          <p>
            При оплате долгосрочных периодов предоставляется скидка: 2 мес —
            10%; 3–4 мес — 15%; 5 мес — 20%; 6–7 мес — 25%; 8 мес — 30%; 9 мес —
            35%; 10–12 мес — 40%. Скидка применяется к расчётной стоимости
            периода.
          </p>

          <h4>4.3. Порядок оплаты</h4>
          <p>
            Оплата — авансом за весь период единовременным платежом через
            YooKassa (ООО «Яндекс.КК», ИНН 7731471470) банковской картой.
          </p>
          <p>
            Обязательство по оплате считается исполненным с момента зачисления
            средств на счёт Лицензиара.
          </p>
          <p>
            Лицензиар применяет НПД (самозанятый). НДС не облагается. Ставка
            налога — 6%. Чек направляется через «Мой налог».
          </p>

          <h4>4.4. Доступ и блокировка</h4>
          <p>
            Доступ к платному Тарифу — с даты зачисления первого платежа. При
            непоступлении следующей оплаты доступ блокируется, данные
            сохраняются 30 дней.
          </p>

          <h4>4.5. Возврат средств</h4>
          <p>
            Лицензиат вправе требовать возврата средств, уплаченных за Платежный
            период, в течение 14 календарных дней с даты оплаты.
          </p>
          <p>
            <strong>Формула расчёта:</strong>
          </p>
          <p>
            СуммаВозврата = СуммаОплаты − СтоимостьИспользованныхДней, где
            СтоимостьИспользованныхДней = (МесячнаяСтоимость / 30) ×
            КоличествоДней.
          </p>
          <p>
            КоличествоДней — календарные дни с даты оплаты до даты обращения (не
            менее 1). МесячнаяСтоимость рассчитывается исходя из ставки за
            сотрудника, скидки за объём месяцев и количества сотрудников (п.
            4.1–4.2).
          </p>
          <p>
            Возврат осуществляется на карту, с которой производилась оплата,
            через YooKassa в срок до 30 календарных дней с даты обращения. При
            возврате доступ к платному Тарифу прекращается, Лицензиат
            переводится на Тариф, действовавший до оплаты.
          </p>
          <p>
            <strong>Возврат не производится:</strong> по истечении 14 дней с
            даты оплаты; если Платежный период полностью истёк; при расторжении
            по вине Лицензиата; если платёж уже был возвращён.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>5. Права и обязанности сторон</h3>
          <p>
            <strong>Лицензиар обязуется:</strong> обеспечить круглосуточный
            доступ (кроме ПТР с 00:00 до 06:00 МСК), резервное копирование раз в
            24 часа, техподдержку (рабочие дни 09:00–19:00), уведомлять об
            изменениях за 14 дней.
          </p>
          <p>
            <strong>Лицензиат обязуется:</strong> своевременно оплачивать,
            использовать ПО законно, не передавать доступ третьим лицам,
            самостоятельно получать согласия клиентов на обработку ПД (152-ФЗ),
            самостоятельно оформлять отношения с клиентами (54-ФЗ), не принимать
            оплату за услуги через Лицензиара.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>6. Ответственность сторон</h3>
          <p>
            Лицензиар не является стороной договора между Лицензиатом и его
            клиентами. Ответственность Лицензиара ограничена суммой оплаты за 6
            последних месяцев. Упущенная выгода не возмещается.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>7. Интеллектуальная собственность</h3>
          <p>
            Исключительные права на ПО принадлежат Лицензиару. Лицензиату
            предоставляется только право использования. Запрещены любые формы
            копирования, модификации, декомпиляции или сублицензирования.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>8. Срок действия и расторжение</h3>
          <p>
            Договор действует до окончания оплаченного периода. Автоматическая
            пролонгация не осуществляется.
          </p>
          <p>
            При расторжении по инициативе Лицензиата ранее окончания оплаченного
            периода возврат средств осуществляется в порядке п. 4.5 при условии
            соблюдения 14-дневного срока с даты оплаты. По истечении этого срока
            средства не возвращаются, за исключением случаев, предусмотренных
            законодательством РФ.
          </p>
          <p>
            При расторжении Лицензиаром без вины Лицензиата — возврат
            пропорционально оставшемуся периоду.
          </p>
          <p>
            После расторжения данные доступны для экспорта 30 дней, затем
            уничтожаются.
          </p>
        </section>

        <section className={styles.content__section}>
          <h3>9. Заключительные положения</h3>
          <p>
            Договор регулируется законодательством РФ. Споры — по месту
            нахождения Лицензиара. Изменения вступают в силу через 14 дней после
            публикации.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>Часть 2. Поручение на обработку персональных данных (DPA)</h2>
          <p>
            <em>Приложение № 1 к Лицензионному договору</em>
          </p>
          <p>
            Настоящее Поручение является неотъемлемой частью Лицензионного
            договора и регулирует отношения по обработке персональных данных
            клиентов Лицензиата (салона).
          </p>

          <h4>Стороны</h4>
          <p>
            <strong>Оператор</strong> — Лицензиат (салон, студия, клиника,
            частный мастер).
          </p>
          <p>
            <strong>Процессор</strong> — Лицензиар (правообладатель BookUp).
          </p>

          <h4>Цели обработки</h4>
          <p>
            Обеспечение функционирования ПО: ведение расписания, запись
            клиентов, уведомления (VK Bot, email, SMS), хранение истории,
            отчётность.
          </p>

          <h4>Перечень данных</h4>
          <p>
            ФИО, телефон, email, дата рождения, комментарии, история записей,
            фотографии (с согласия клиента).
          </p>

          <h4>Субпроцессоры (третьи лица)</h4>
          <p>
            Оператор вправе передавать персональные данные, а также поручать
            обработку данных третьим лицам. К таким третьим лицам могут
            относиться, в частности: платёжный партнёр (YooKassa), сервис
            уведомлений (VK Bot), хостинг-провайдер, а также иные лица для
            достижения целей обработки. Перечень третьих лиц может изменяться.
          </p>

          <h4>Меры безопасности</h4>
          <p>
            HTTPS (TLS 1.2/1.3), хэширование паролей Argon2, JWT-токены (15 мин
            / 30 мин), разграничение ролей, логирование, резервное копирование,
            серверы на территории РФ.
          </p>

          <h4>Локализация</h4>
          <p>
            Обработка данных — на территории РФ. Трансграничная передача не
            осуществляется.
          </p>

          <h4>Срок хранения и удаление</h4>
          <p>
            Данные обрабатываются в течение срока действия Договора. По
            требованию Оператора или по окончании Договора данные уничтожаются в
            течение 30 дней.
          </p>
        </section>
      </div>
    </PageLayout>
  );
};
